// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminPortalAccess } from "./platform-admin-portal-access";
import { platformAdminPortalSecurity } from "./platform-admin-portal-security";
import { platformAdminPortalUiSemantics } from "./platform-admin-portal-ui-semantics";

export const platformAdminPortalManagement = {
  ...platformAdminPortalUiSemantics,
  ...platformAdminPortalSecurity,
  ...platformAdminPortalAccess,
  summaryVisible: "表示中",
  summaryEntries: "入口数",
  deleteGroupTitle: "ポータルグループを削除",
  deleteGroupConfirm:
    "グループ「{name}」を削除しますか？このグループに入口がない場合のみ削除できます。",
  deleteGroupError:
    "このグループにはまだ {count} 件の入口があります。先に入口のグループを調整してください。",
  deleteGroupSuccess: "ポータルグループを削除しました",
  title: "ポータル管理",
  subtitle: "ポータル外観、入口編成、接入設定、安全方針を一元管理します。",
  appearanceTitle: "ポータル外観",
  appearanceSubtitle: "ポータルの Logo、タイトル、副題、表示文言を管理します。",
  appearanceNotice:
    "このページではポータル Logo、タイトル、副題、ログイン説明、ホーム歓迎文、フッター文言を管理します。グループ名は Portal Groups で管理します。",
  portalName: "ポータル名",
  portalSubtitle: "ポータル副題",
  loginTitle: "ログインページタイトル",
  loginSubtitle: "ログイン説明",
  homeWelcome: "ホーム歓迎文",
  footerText: "フッター文言",
  logoLabel: "Logo",
  logoTitle: "ポータル Logo",
  logoDescription:
    "アップロード後は資産センターのブランド空間に保存され、ポータル表示へ同期されます。",
  uploadLogo: "Logo をアップロード",
  replaceLogo: "Logo を差し替え",
  clearLogo: "Logo をクリア",
  logoCleared: "Logo をクリアしました",
  appearanceRestored: "既定値に戻しました",
  appearanceLogoUpdated: "Logo を更新しました",
  entriesTitle: "ポータル入口表示",
  entriesSubtitle:
    "ポータル上の表示名、説明、分類、並び順、アイコン、表示状態を管理します。標準のサービス識別子、ドメイン、ポートはサービス入口レジストリから取得します。",
  groupsTitle: "ポータルグループ",
  groupsSubtitle: "ポータルグループ（ナビフォルダ）と表示順を管理します。",
  objects: {
    entry: "ポータル入口表示",
    group: "ポータルグループ",
  },
  groupsCreate: "ポータルグループを作成",
  groupsEditTitle: "ポータルグループを編集 · {name}",
  groupsEditTitleShort: "ポータルグループを編集",
  groupsSaveSuccess: "ポータルグループを更新しました",
  groupsCreateSuccess: "ポータルグループを作成しました",
  groupKey: "グループ識別子",
  groupName: "グループ名",
  groupLookup: "ポータルグループを検索",
  groupPickerTitle: "ポータルグループを検索",
  groupPickerApply: "ポータルグループを反映",
  groupPickerEmpty: "選択できるポータルグループがありません",
  groupPickerRequired: "先にポータルグループを選択してください",
  groupDescription: "グループ説明",
  groupStatus: "グループ状態",
  groupSortOrder: "グループ表示順",
  entryName: "ポータル表示名",
  entryDescription: "ポータル表示説明",
  entryGroup: "ポータルグループ",
  entrySortOrder: "ポータル表示順",
  entryDomain: "入口ドメイン",
  entryAddress: "入口 URL",
  entryActions: "ポータル入口操作",
  entryDetailTitle: "ポータル入口詳細 · {name}",
  entryBasicTitle: "ポータル表示設定",
  entryEnabled: "ポータル有効",
  entryIconAppstore: "アプリ",
  entryIconFolder: "フォルダ",
  entryIconRead: "ドキュメント",
  entryIconRocket: "ロケット",
  entryIconUser: "ユーザー",
  entryEditTitle: "入口編成を編集 · {name}",
  entryEditTitleShort: "入口編成を編集",
  entryUpdateSuccess: "入口編成を更新しました",
  groupPrimary: "主要エリア",
  groupTools: "ツールエリア",
} as const;
